import * as React from 'react'
import { PropsWithChildren, ReactElement, useMemo } from 'react'
import { Dialog, DialogType, IDialogProps, mergeStyleSets } from '@fluentui/react'

type Props = PropsWithChildren<IDialogProps>

// noinspection JSUnusedGlobalSymbols
export default function LegacyBaseDialog(props: Props): ReactElement {
    const styles = useMemo(() => mergeStyleSets({ main: { width: '100% !important' } }, props.styles), [props.styles])
    const dialogContentProps = useMemo(() => ({ type: DialogType.largeHeader, ...props.dialogContentProps }), [props.dialogContentProps])
    return (
        <Dialog minWidth={320} maxWidth={480} {...props} dialogContentProps={dialogContentProps} styles={styles}>
            {props.children}
        </Dialog>
    )
}
